import { demoSvc } from "./demo.service";

class MappingService {
  mapContents(wpContents) {
    wpContents = this.filterEffectiveContents(wpContents);

    const contents = {};
    for (let i = 0; i < wpContents.length; i++) {
      const fields = wpContents[i].fields;
      contents[fields.route] = {
        title: fields.title,
        description: fields.description,
        popup: fields.popup?.show ? fields.popup : false
      };
      // console.log(fields.route, contents[fields.route])
    }
    return contents;
  }

  mapChapters(wpChapters) {
    return wpChapters.reverse().map(ch => {
      const fields = ch.fields;
      return {
        slug: ch.slug,
        title: ch.title,
        teaserImage: fields.teaserImage,
        videoUrl: fields.videoUrl,
        rules: fields.rules || []
      }
    });
  }

  mapQuestions(wpQuestions) {
    return wpQuestions.reverse().map(ch => {
      const fields = ch.fields;
      return {
        ...fields
      }
    });
  }

  filterEffectiveContents(wpContents) {
    if (demoSvc.isLiveInstance()) {
      return wpContents.filter(c => c.fields.live);
    } else if (demoSvc.isDemoInstance()) {
      // On demo keep the live data.
      const combinedPaths = new Map();
      wpContents.forEach(c => {
        combinedPaths.set(c.fields.route, c.fields.route);
      });

      const combinedContents = [];
      combinedPaths.forEach((route) => {
        let found = wpContents.find(c => !c.fields.live && route === c.fields.route);
        if (!found) {
          found = wpContents.find(c => c.fields.live && route === c.fields.route);
        }
        found && combinedContents.push(found);
      })
      return combinedContents;
    }
  }
}
export const mappingSvc = new MappingService();
